export function WorpelButton(params) {
  return (
    <a
      href="/"
      className="px-5 py-2 text-xs font-bold uppercase text-white hover:text-stone-200 md:px-7 md:py-3 md:text-sm"
    >
      Play Worpel
    </a>
  );
}
